import {FetchService} from "dc-services/fetch.service";
import {getNewFlashmessage} from 'cronus-theme/default/global/js/flashmessages';
import {saveConfiguration} from './configurationManager.js';
import {captureAiVisionHandover} from './aiVisionCapture.js';
import {getGlobals} from './utils.js';
import {shopLanguageCode, shopUrl} from '../shopUrl';

/**
 * Button "Im AI Vision Studio rendern" in the configurator panel (portal only, #233679).
 * Saves the configuration, captures high-res views and masks, creates a handover and opens
 * the studio with it. The button is hidden on eila.de via CSS and shown in the portal theme.
 */

const DEFAULTS = {
    de: {
        label: 'Im AI Vision Studio rendern',
        loading: 'Studio wird vorbereitet …',
        error: 'Die Konfiguration konnte nicht an das AI Vision Studio übergeben werden. Bitte versuche es erneut.',
        unitState: 'aufgebaut, einsatzbereit wie im Konfigurator',
    },
    en: {
        label: 'Render in AI Vision Studio',
        loading: 'Preparing the studio …',
        error: 'The configuration could not be handed over to the AI Vision Studio. Please try again.',
        unitState: 'set up and ready for use as shown in the configurator',
    },
};

function getLanguage() {
    return shopLanguageCode() === 'en' ? 'en' : 'de';
}

function getCheckedSize() {
    const panel = document.querySelector('.configuratorPanel');
    const input = panel?.querySelector('input[name="modelSize"]:checked');
    if (!input) {
        return {sizeName: '', modelKey: ''};
    }
    const label = panel.querySelector(`label[for="${input.id}"]`) || input.closest('label');
    return {sizeName: label ? label.textContent.trim() : '', modelKey: input.value || ''};
}

function getUnitName() {
    const headline = document.querySelector('.itemcardEilaHeadline') || document.querySelector('.configuratorHeadline');
    return headline ? headline.textContent.trim() : '';
}

function getStudioUrl(handoverUuid) {
    return shopUrl(`account/?action=aivisionstudio&handover=${encodeURIComponent(handoverUuid)}`);
}

export function initAiVisionStudioButton() {
    const button = document.querySelector('.configuratorButtonAiVision');
    // rollout: not released for this customer (body class set by frontend_portal.php)
    if (!button || document.body.classList.contains('aiVisionStudioDisabled')) {
        return;
    }
    const tc = getGlobals().tc || {};
    if (!button.textContent.trim()) {
        button.textContent = tc.ai_vision_studio_render || DEFAULTS[getLanguage()].label;
    }

    button.addEventListener('click', async (event) => {
        event.preventDefault();
        if (button.classList.contains('is-loading')) {
            return;
        }
        const label = button.textContent;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.textContent = tc.ai_vision_studio_loading || DEFAULTS[getLanguage()].loading;

        try {
            const saveResult = await saveConfiguration(null, '', 'save');
            const configUuid = saveResult?.data?.uuid || saveResult?.uuid || '';
            if (!saveResult?.success || !configUuid) {
                throw new Error('SAVE_FAILED');
            }

            const {views, masks} = await captureAiVisionHandover({scale: 2, withMasks: true});
            const {sizeName, modelKey} = getCheckedSize();
            const response = await FetchService.post('/em/aiVisionStudio/createHandover', {
                configUuid,
                unitName: getUnitName() || sizeName,
                sizeName,
                modelKey,
                unitState: tc.ai_vision_studio_unit_state || DEFAULTS[getLanguage()].unitState,
                views,
                masks,
            });
            if (!response?.success || !response.data?.uuid) {
                throw new Error(response?.message || 'HANDOVER_FAILED');
            }

            window.location.href = getStudioUrl(response.data.uuid);
        } catch (error) {
            console.error('[AI VISION STUDIO] handover failed', error);
            getNewFlashmessage(tc.ai_vision_studio_handover_error || DEFAULTS[getLanguage()].error, 3);
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            button.textContent = label;
        }
    });
}
